import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className="flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-foreground-500 py-4">
      <Link to="/" className="hover:text-accent-400 transition-colors flex items-center gap-1">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-600"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-accent-400 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}